export const getApiErrorMessage = (
  error: unknown,
  fallback: string
): string => {
  const candidate = error as
    | { response?: { data?: { message?: string } }; message?: string }
    | null
    | undefined;
  return (
    candidate?.response?.data?.message || candidate?.message || fallback
  );
};
